(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityInputTypeScheduler', activityInputTypeScheduler);

    function activityInputTypeScheduler() {
        return {
            restrict: 'E',
            scope: {
                inputData: '=',
                model: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: activityInputTypeSchedulerCtrl,
            templateUrl: 'common/app/components/activities/activity-input/types/scheduler'
        };
    }

    function activityInputTypeSchedulerCtrl() {
        var vm = this;
        this.$onInit = function() {
            vm.elements = vm.inputData.options.elements;
            vm.labels = vm.inputData.options.labels;
        }
    }
})();